import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';

// Shared slotProps for TextField
const textFieldProps = {
  className: 'audit-filter-inputs',
  sx: { height: '33px', width: '90%' },
  inputProps: { readOnly: true }, // disables manual typing
};

const DateFilter = (props) => {
  const {
    handleDateChange,
    location,
    history,
    userTimezone,
    date_value,
    max_date = null,
    _views = ['year', 'month', 'day'],
    min_date = null,
    daily = false,
    disable = false,
    max_time = null,
  } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      {daily ? (
        <TimePicker
          timezone={userTimezone}
          className='audit-filter-inputs'
          sx={{ height: '33px', width: '90%' }}
          ampm={false}
          views={['hours', 'minutes']}
          value={date_value}
          onChange={(newValue) => {
            if (newValue !== null) {
              handleDateChange(newValue);
            }
          }}
          disabled={disable}
          maxTime={max_time ?? undefined}
          slotProps={{ textField: textFieldProps }}
        />
      ) : (
        <DateTimePicker
          // label="Select Date & Time"
          ampm={false}
          timezone={userTimezone}
          value={date_value}
          onChange={(newValue) => {
            if (newValue !== null) {
              handleDateChange(newValue);
            }
          }}
          format='MMMM DD, YYYY'
          viewRenderers={{
            hours: renderTimeViewClock,
            minutes: renderTimeViewClock,
            seconds: renderTimeViewClock,
          }}
          maxDateTime={max_date && max_date !== undefined ? max_date : null}
          minDateTime={min_date && min_date !== undefined ? min_date : null}
          className='audit-filter-inputs'
          sx={{ height: '33px', width: '90%' }}
          views={[..._views]}
          disabled={disable}
          slotProps={{ textField: textFieldProps }}
        />
      )}
    </LocalizationProvider>
  );
};

const mapStateToProps = (state) => ({});

export default withRouter(connect(mapStateToProps, {})(DateFilter));
